import React, {useEffect} from 'react';
import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import picto_hotel_integration from 'images/picto_hotel_integration.svg';
import picto_buyer_integration from 'images/picto_buyer_integration.svg';
import styled from 'styled-components';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	gap: 10px;
	flex-grow: 1;
`;

const Row = styled.div`
	flex-wrap: wrap;
	display: flex;
	flex-direction: row;
	width: 100%;
	padding: 40px 0;
	@media (min-width: 980px) { padding: 40px 0; }
`;

const Buttons = styled.div`
	flex-wrap: wrap;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	gap: 20px;

	@media (min-width: 980px) {
		flex-direction: row;
		align-items: flex-start;
		gap: 40px;
	}
	
	justify-content: center;

	a {
		border: 2px solid #034781;
		border-radius: 5px;
		height: 280px;
		margin: 0px 40px;

		@media (min-width: 980px) {
			width: 460px;
			&.square { height: 280px; }
			margin: 0px;
		}

		//@media (min-width: 540px) and (max-width: 979px) {
		//	width: 300px !important;
		//	height: 300px !important;
		//}
		
		//&:nth-child(n+2) {
		//	@media (min-width: 660px) { margin-left: 20px; }
		//	@media (max-width: 659px) { margin-top: 20px; }
		//	@media (min-width: 1280px) { margin-left: 40px; }
		//}
	}
`;

const Main = () => {
	const { t } = useTranslation();

	useEffect(() => window.scrollTo(0, 0), []);

	return (
		<Container>
			<Row>
				<Buttons>
					<Link to="/buyer_integration" className='flex square flex column align-center justify-center font-bold font-24 text-uppercase color-blue hover text-center'>
						<img src={picto_buyer_integration} alt="" className='pictogram margin-bottom-20' />
						{t('Интеграция с покупателями')}
					</Link>

					<Link to="/hotel_integration" className='flex square flex column align-center justify-center font-bold font-24 text-uppercase color-blue hover text-center'>
						<img src={picto_hotel_integration} alt="" className='pictogram margin-bottom-20' />
						{t('Интеграция с отелями')}
					</Link>
				</Buttons>
			</Row>
		</Container>
	);
};

export default Main;